import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="comprar" className="relative z-10 py-16 md:py-24 px-4 bg-gradient-to-b from-[#1a1030] to-[#0f0a1e]" data-id="element-80">
      <div className="max-w-md mx-auto" data-id="element-81">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-82">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-2" data-id="element-83">
            Elegí tu pack
          </h2>
          <p className="text-lg text-white/70" data-id="element-84">
            Acceso inmediato a todos los recursos
          </p>
        </div>

        {/* Compact Pricing Card */}
        <div className="bg-white rounded-2xl overflow-hidden shadow-2xl shadow-black/30" data-id="element-85">
          {/* Top section */}
          <div className="p-5 pb-4" data-id="element-86">
            {/* Badge */}
            <div className="inline-block bg-[#F5C842]/15 border border-[#F5C842]/40 rounded-md px-3 py-1 mb-3" data-id="element-87">
              <span className="text-[#D4AF37] font-bold text-xs uppercase tracking-wider" data-id="element-88">
                Oferta Limitada
              </span>
            </div>

            {/* Product Name */}
            <h3 className="text-xl font-black text-gray-900 mb-1" data-id="element-89">
              Sistema Pro Cartas Natales
            </h3>
            <p className="text-gray-500 text-sm mb-4" data-id="element-90">
              Todo lo que necesitás para tus informes profesionales
            </p>

            {/* Pricing */}
            <div className="mb-4" data-id="element-91">
              <span className="text-gray-400 text-base line-through mr-2" data-id="element-92">
                $49.990
              </span>
              <div className="flex items-center gap-3 mt-1" data-id="element-93">
                <span className="text-4xl font-black text-gray-900" data-id="element-94">
                  $19.990
                </span>
                <span className="bg-[#D4AF37] text-white text-xs font-bold px-2.5 py-1 rounded-md" data-id="element-95">
                  -60%
                </span>
              </div>
            </div>

            {/* CTA Button */}
            <a href="https://checkout.empezahoy.shop/cart/48089967624424:1" className="block w-full text-center bg-gradient-to-r from-red-600 via-red-500 to-red-600 hover:from-red-500 hover:via-red-400 hover:to-red-500 text-white font-bold py-3.5 rounded-xl transition-all duration-300 transform hover:scale-[1.02] cta-pulse shadow-lg text-lg mb-2" data-id="element-96">
              Sí, quiero esta oferta
            </a>

            <p className="text-gray-400 text-xs text-center" data-id="element-97">
              Pago único · Acceso de por vida
            </p>
          </div>

          {/* Divider */}
          <div className="border-t border-gray-200 mx-5" data-id="element-98" />

          {/* Includes section */}
          <div className="p-5 pt-4" data-id="element-99">
            <p className="text-gray-900 font-bold text-sm uppercase tracking-wider mb-3" data-id="element-100">
              Incluye:
            </p>
            <div className="space-y-2.5" data-id="element-101">
              <div className="flex items-start gap-2.5" data-id="element-102">
                <CheckIcon className="w-4 h-4 text-[#D4AF37] flex-shrink-0 mt-0.5" data-id="element-103" />
                <span className="text-gray-700 text-sm" data-id="element-104">
                  Sistema completo de informes profesionales
                </span>
              </div>
              <div className="flex items-start gap-2.5" data-id="element-105">
                <CheckIcon className="w-4 h-4 text-[#D4AF37] flex-shrink-0 mt-0.5" data-id="element-106" />
                <span className="text-gray-700 text-sm" data-id="element-107">
                  Plantillas premium editables
                </span>
              </div>
              <div className="flex items-start gap-2.5" data-id="element-108">
                <CheckIcon className="w-4 h-4 text-[#D4AF37] flex-shrink-0 mt-0.5" data-id="element-109" />
                <span className="text-gray-700 text-sm" data-id="element-110">
                  Biblioteca de 25 interpretaciones listas
                </span>
              </div>
              <div className="flex items-start gap-2.5" data-id="element-111">
                <CheckIcon className="w-4 h-4 text-[#D4AF37] flex-shrink-0 mt-0.5" data-id="element-112" />
                <span className="text-gray-700 text-sm" data-id="element-113">
                  Kit de ingresos recurrentes astrológicos
                </span>
              </div>
              <div className="flex items-start gap-2.5" data-id="element-114">
                <CheckIcon className="w-4 h-4 text-[#D4AF37] flex-shrink-0 mt-0.5" data-id="element-115" />
                <span className="text-gray-700 text-sm" data-id="element-116">
                  3 Bonos exclusivos gratis (solo hoy)
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex items-center justify-center gap-5 mt-6 text-white/60" data-id="element-117">
          <div className="flex items-center gap-1.5" data-id="element-118">
            <ShieldCheckIcon className="w-4 h-4 text-green-400" data-id="element-119" />
            <span className="text-xs" data-id="element-120">Compra segura</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-121">
            <ZapIcon className="w-4 h-4 text-[#F5C842]" data-id="element-122" />
            <span className="text-xs" data-id="element-123">Acceso inmediato</span>
          </div>
        </div>
      </div>
    </section>;
}